<template>
    <div>
        <div class="table-blog">
        <div
          style="position: absolute;top: 45%; left: 50%; width: 10%; z-index: 2;"
          v-show="loading == true"
        >
          <md-progress-spinner :md-stroke="8" :md-diameter="65" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div class="head-table">
          <div class="col" style="width :15%">Province</div>
          <div class="col" style="width :25%;text-align:left">Customer Name</div>
          <div class="col" style="width :20%;text-align:left">Campaign Name</div>
          <div class="col" style="width :25%;text-align:left">Reward Name</div>
          <div class="col" style="width :15%;text-align:center">Number of Reward</div>
        </div>
        <div class="body-table">
          <div
            class="row-table"
            v-for="(item , index) in searched"
            :key="'row-table-'+index"
            @click="showDetailPanel(item)"
          >
            <div
              class="col top-line"
              style="width :15%;font-family:kanit;word-wrap: break-word;"
            >{{ item.province }}</div>
            <div
              class="col top-line"
              style="width :25%;text-align:left"
            >{{ item.title }}</div>
            <div
              class="col top-line"
              style="width :20%;text-align:left"
            >{{ item.campaign_title }}</div>
            <div
              class="col top-line"
              style="width :25%;text-align:left"
            >{{ item.reward_name }}</div>
            <div
              class="col top-line"
              style="width :15%;text-align:center"
            >{{ item.number_reward }}</div>
          
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import CampaignService from "@/services/campaign";

export default {
  name: 'track-reward',
  data(){
    return{
      searched: [],
      campaign: [],
      loading:  false
    }
  },
  created(){
  this.loading = true;
    CampaignService.getReportDelivery().then(res => {
      this.campaign = res;
      this.searched = this.campaign;
      this.searchedTemp = _.cloneDeep(this.campaign);
      this.loading = false;
    });
  }
}
</script>


<style lang="scss" scoped>
.table-blog {
      width: 100%;
      padding-left: 5px;
      padding-right: 5px;
      // padding: 0px 30px 30px 30px;
      .col {
        padding-right: 10px;
        // padding-left:20px;
      }
      .head-table {
        margin-bottom: 20px;
        display: -webkit-box;
        font-size: 13px;
        font-family: lato;
        font-weight: bold;
        padding-left: 25px;
        padding-right: 25px;
      }
      .body-table {
        height: calc(100vh - 205px);
        overflow-y: scroll;
        overflow-x: hidden;
        .row-table {
          padding-left: 25px;
          padding-right: 20px;
          display: -webkit-box;
          font-family: lato;
          font-size: 13px;
          margin-bottom: 5px;
          .top-line {
            padding-top: 7px;
            padding-bottom: 7px;
          }
        }
        .row-table:hover {
          background: rgba(236, 236, 235, 1);
          cursor: pointer;
          border-radius: 3px;
        }
      }
      .body-table::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
    .footer-table {
      display: block;
      text-align: center;
      margin-top: 5px;
      padding-bottom: 15px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
</style>